import { useMemo } from "react";
import { Util } from "@xt/xtbase";
import store from "store";

// import { TradeSideEnum } from "store/trade";
import useCoinMemo from "./useCoinMemo";

const { Big } = Util;

export const useLeverAccount = () => {
  const { leverAccountOverview } = store.balances;
  const { coinQuantityPrecisionCurrency, coinPricePrecisionCurrency } = useCoinMemo();

  const totalQuantity = useMemo(() => {
    if (!leverAccountOverview) return "0";
    const { tradeAmount, tradeFreezeAmount } = leverAccountOverview.sellCoin;
    return Big(tradeAmount || 0)
      .plus(tradeFreezeAmount || 0)
      .toFixed();
  }, [leverAccountOverview]); //总资产，卖方币
  const totalPrice = useMemo(() => {
    if (!leverAccountOverview) return "0";
    const { tradeAmount, tradeFreezeAmount } = leverAccountOverview.buyCoin;
    return Big(tradeAmount || 0)
      .plus(tradeFreezeAmount || 0)
      .toFixed();
  }, [leverAccountOverview]); //总资产，卖方币

  //持仓（Position）=净资产=总资产-已借-利息
  const positionQuantity = useMemo(() => {
    if (!leverAccountOverview) return "0";
    const { tradeAmount, tradeFreezeAmount, hasLoanAmount, interestAmount } = leverAccountOverview.sellCoin;
    return Big(tradeAmount || 0)
      .plus(tradeFreezeAmount || 0)
      .minus(hasLoanAmount || 0)
      .minus(interestAmount || 0)
      .toFixed();
  }, [leverAccountOverview]);
  const positionPrice = useMemo(() => {
    if (!leverAccountOverview) return "0";
    const { tradeAmount, tradeFreezeAmount, hasLoanAmount, interestAmount } = leverAccountOverview.buyCoin;
    return Big(tradeAmount || 0)
      .plus(tradeFreezeAmount || 0)
      .minus(hasLoanAmount || 0)
      .minus(interestAmount || 0)
      .toFixed();
  }, [leverAccountOverview]);

  const positionQuantityLabel = useMemo(
    () => Big(positionQuantity).toFixedCy(coinQuantityPrecisionCurrency),
    [positionQuantity, coinQuantityPrecisionCurrency]
  );
  const positionPriceLabel = useMemo(() => Big(positionPrice).toFixedCy(coinPricePrecisionCurrency), [positionPrice, coinPricePrecisionCurrency]);

  return {
    totalQuantity,
    totalPrice,
    positionQuantity,
    positionPrice,
    positionQuantityLabel,
    positionPriceLabel,
  };
};

export default useLeverAccount;
